import { SunIcon, MoonIcon } from '@heroicons/react/24/outline'
import { useThemeStore } from '@lipaflow/shared'

export default function DarkModeToggle() {
  const { isDark, toggleDark } = useThemeStore()

  return (
    <button
      onClick={toggleDark}
      className="rounded-lg p-2 text-stone-500 hover:bg-stone-100 dark:text-stone-400 dark:hover:bg-stone-700"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <SunIcon className="h-5 w-5" />
      ) : (
        <MoonIcon className="h-5 w-5" />
      )}
    </button>
  )
}
